/**
 * Linhas da tabela "Patrimônio por membro" a partir do que já está na store.
 *
 * Fonte ÚNICA. A tela antiga de grupo monta essa tabela em DUAS sub-abas (Carteira atual e
 * Evolução patrimonial) pelo mesmo mixin; em Carteiras as views são independentes, e a fiação
 * (breakdown por membro + statistics + posição + membros + paleta) estava copiada. Cópia number
 * dois já tinha divergido: a Evolução simplesmente não montava a tabela.
 *
 * O breakdown por membro NÃO vem na consolidação: é uma requisição própria com
 * `group_by=id_cliente` (`apiConsolidatorGroupWalletAnalysis.carregarBreakdownPorMembro`). Quem
 * monta a tabela dispara essa carga.
 */
import store from '@state/store'
import { REPORT_PALETTE } from '@modules/consolidator/constants/Color'
import { buildGroupWalletRows } from '@modules/consolidator/utils/build-group-wallet-rows/build-group-wallet-rows'

/**
 * @returns {Object} `{ rows, totalRow }` no contrato do `GroupWalletTable`
 */
export const resolveGroupMemberRows = () => {
  const wallet = store.getters['consolidator/walletAnalysis']
  return buildGroupWalletRows({
    breakdown: store.getters['consolidator/familyGroupMemberBreakdown'],
    portfolioStatistics: (wallet && wallet.portfolio_statistics) || null,
    posicaoCompleta: (wallet && wallet.posicao_completa) || null,
    membros: (wallet && wallet.membros) || [],
    palette: REPORT_PALETTE,
  })
}

/**
 * @returns {Array} `membros[]` da consolidação do grupo, sempre array
 */
export const resolveGroupMembers = () => {
  const wallet = store.getters['consolidator/walletAnalysis']
  return (wallet && wallet.membros) || []
}
